import { HoverPicture } from 'kit'
import { HoverPictureProps } from 'components/kit/hoverpicture/hoverpicture'
import styles from './hoverpicturecollection.css'

type HoverPictureCollectionProps = {
  value: {
    hover_pictures: Array<HoverPictureProps>
  }
}

const HoverPictureCollection = (props: HoverPictureCollectionProps): JSX.Element => {
  const {
    value: { hover_pictures },
  } = props
  return (
    <div className={styles.wrapper}>
      {hover_pictures.map((picture, index) => (
        <HoverPicture key={String(index)} image={picture.image} description={picture.description} name={picture.name} />
      ))}
    </div>
  )
}

export default HoverPictureCollection
